import { Injectable } from '@angular/core';
import { ActionSheetController, AlertController, Loading, LoadingController, ModalController, ToastController } from 'ionic-angular';

@Injectable()
export class ViewProvider {

  constructor(private alertCtrl: AlertController, private toastCtrl: ToastController, private loadingCtrl: LoadingController,
    private actionSheetCtrl: ActionSheetController, public modalCtrl: ModalController) {
  }

  public showMessage(text, okHandler?) {
    let alert = this.alertCtrl.create({
      title: 'Informação',
      subTitle: text,
      enableBackdropDismiss: false,
      buttons: (okHandler == null ? ['OK'] : [{
        text: 'OK',
        handler: okHandler
      }])
    });

    alert.present();
  }

  public showWarning(text) {
    this.showWarn(text);
  }

  public showWarn(text) {
    let alert = this.alertCtrl.create({
      title: 'Aviso',
      subTitle: text,
      enableBackdropDismiss: false,
      buttons: ['OK']
    });

    alert.present();
  }

  public showError(text) {
    let alert = this.alertCtrl.create({
      title: 'Falha',
      subTitle: text,
      enableBackdropDismiss: false,
      buttons: ['OK']
    });

    alert.present();
  }

  public showToastMessage(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      cssClass: 'toast toast-info'
    });
    toast.present();
  }

  public showToastWarn(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      cssClass: 'toast toast-warn'
    });
    toast.present();
  }

  public showToastError(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      cssClass: 'toast toast-error'
    });
    toast.present();
  }

  public showConfirm(text, yesHandler, noHandler = () => { }) {
    let alert = this.alertCtrl.create({
      title: 'Confirmar',
      subTitle: text,
      buttons: [{
        text: 'Não',
        role: 'cancel',
        handler: noHandler
      },
      {
        text: 'Sim',
        handler: yesHandler
      }]
    });

    alert.present();
  }

  public showConfirmWithButtons(text, buttons) {
    let alert = this.alertCtrl.create({
      title: 'Confirmar',
      subTitle: text,
      buttons: buttons
    });

    alert.present();
  }

  public showLoading(): Loading {
    let loading = this.loadingCtrl.create({
      content: 'Aguarde...',
      dismissOnPageChange: false
    });

    loading.present();

    return loading;
  }

  public hideLoading(loading: Loading) {
    loading.dismiss();
  }

  /**
   * Os campos dos botões são os mesmos do ActionSheetController
   * @see https://ionicframework.com/docs/api/components/action-sheet/ActionSheetController/
   * 
   * @param buttons Array de botões com as opções
   * @param title Opcional.
   */
  public showActionSheet(buttons: Array<any>, title = undefined) {
    let actionSheet = this.actionSheetCtrl.create({
      title: title,
      buttons: buttons
    });
    actionSheet.present();
  }


  public showModalPage(page, params = {}, dimissAction = null) {
    let modalPage = this.modalCtrl.create(page, params);

    if (dimissAction) {
      modalPage.onDidDismiss(dimissAction);
    }

    modalPage.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/view.ts